import React from 'react';
import MissionControlCanvas from './organisms/MissionControlCanvas';
import './MissionControlDemo.css';

const MissionControlDemo = () => (
  <section className="mc-demo" aria-label="Mission Control canvas demo">
    <div className="mc-demo-counters" aria-hidden="true">
      <div className="mc-demo-counter-card">
        <strong>0</strong>
        <small>ACTIVE</small>
      </div>
      <div className="mc-demo-counter-card">
        <strong>0</strong>
        <small>QUEUED</small>
      </div>
    </div>
    <MissionControlCanvas />
  </section>
);

export default MissionControlDemo;
